module.exports = __webpack_public_path__ + "va.svg?8aae3709fb23884b7c01927b3ab56c15";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/va.svg
// module id = 1425
// module chunks = 0